import { _ as e, b as t, c as n, g as r } from "./store-DOfnrSGO.js";
import { a as i, n as a, o, t as s } from "./useKbSearch-Crx1v_rX.js";
import { a as c } from "./dist-BCa5HPz5.js";
import { t as l } from "./collectionIcon-4B-wWD3h.js";
import { useEffect as u, useRef as d } from "react";
import { Fragment as f, jsx as p, jsxs as m } from "react/jsx-runtime";
import { Box as h, ButtonList as g, DropdownButton as _, DropdownButtonContext as v, EmptyState as y, FlexBox as b, Icon as x, IconButton as S, InputText as C, Text as w, Timestamp as T } from "@dixa/lib-shared-habla";
import E from "classnames";
import { Link as D, NavLink as O, Outlet as k, useParams as A } from "react-router-dom";
import { ampli as j } from "lib-shared-tracking";
var M = { articlePageContainer: "_articlePageContainer_4iwz2_1" };
// ../delivery-common/src/components/languagePickerDropdown.tsx
function N({ languageData: e, selectedLanguageId: t, setSelectedLanguageId: n }) {
	let r = e.defaultLanguage.languageId, i = [e.defaultLanguage, ...e.enabledLanguages.filter((e) => e.languageId !== r)];
	return /* @__PURE__ */ p(v.Consumer, { children: ({ toggleDropdown: e }) => /* @__PURE__ */ p(g, { children: i.map((i) => /* @__PURE__ */ m(g.Item, {
		onClick: (t) => {
			t.preventDefault(), t.stopPropagation(), e(), n(i.languageId);
		},
		isSelected: t === i.languageId,
		children: [i.description, i.languageId === r ? " (Default)" : ""]
	}, i.languageId)) }) });
}
// ../delivery-common/src/hooks/useSearchQueryEvent.ts
function P() {
	let [e] = t();
	return ({ languageId: t, searchTerms: n, origin: r, searchResults: i }) => {
		let a = (/* @__PURE__ */ new Date()).valueOf(), o = window.location.href;
		return e({ variables: {
			searchResults: i,
			searchInput: {
				languageId: t,
				searchTerms: n
			},
			ctx: {
				createdAt: a,
				origin: r,
				pageUrl: o
			}
		} });
	};
}
var F = {
	tree: "_tree_uv38j_5",
	node: "_node_uv38j_5",
	active: "_active_uv38j_15",
	categoryTitle: "_categoryTitle_uv38j_15",
	articles: "_articles_uv38j_54",
	article: "_article_uv38j_54",
	category: "_category_uv38j_15",
	topLevelCategory: "_topLevelCategory_uv38j_77",
	articleIcon: "_articleIcon_uv38j_81",
	icon: "_icon_uv38j_81",
	iconWrapper: "_iconWrapper_uv38j_86",
	nodeClosed: "_nodeClosed_uv38j_104",
	articleTitleWrapper: "_articleTitleWrapper_uv38j_118",
	articleTitle: "_articleTitle_uv38j_118"
}, I = ({ article: e }) => /* @__PURE__ */ p(O, {
	to: {
		pathname: `article/${e.id}`,
		search: window.location.search
	},
	className: ({ isActive: e }) => E(e && F.active, F.node, F.article),
	children: /* @__PURE__ */ m("div", {
		className: F.articleTitleWrapper,
		children: [/* @__PURE__ */ p("div", {
			className: E(F.iconWrapper, F.articleIcon),
			children: /* @__PURE__ */ p(x, {
				name: "file",
				className: F.icon
			})
		}), /* @__PURE__ */ p("div", {
			className: F.articleTitle,
			"data-testid": "article-node",
			children: e.title
		})]
	})
}), L = ({ category: e, className: t, isOpen: n = !0, ...r }) => {
	let { isCategoryOpen: i, setCategoryOpen: o } = a(e.id);
	return /* @__PURE__ */ m("div", {
		className: E(t, F.category, F.node, n ? F.nodeOpen : F.nodeClosed),
		...r,
		"data-testid": "category-node",
		children: [
			/* @__PURE__ */ m("div", {
				onClick: () => o(!i),
				className: F.categoryTitle,
				children: [/* @__PURE__ */ p("div", {
					className: F.iconWrapper,
					children: /* @__PURE__ */ p(x, {
						name: `angle-${i ? "down" : "right"}`,
						className: F.icon
					})
				}), e.title]
			}),
			e.articles && e.articles?.length > 0 && /* @__PURE__ */ p("div", {
				className: E(F.articles, i ? F.nodeOpen : F.nodeClosed),
				children: e.articles?.map((e) => /* @__PURE__ */ p(I, { article: e }, e.id))
			}),
			e.categories?.map((e) => /* @__PURE__ */ p(L, {
				category: e,
				isOpen: i
			}, e.id))
		]
	});
}, R = ({ categories: e }) => /* @__PURE__ */ p("div", {
	className: F.tree,
	children: e.map((e) => /* @__PURE__ */ p(L, {
		category: e,
		className: F.topLevelCategory
	}, e.id))
}), z = {
	categoryTreeSidebar: "_categoryTreeSidebar_180yg_1",
	headingContainer: "_headingContainer_180yg_15",
	backButton: "_backButton_180yg_22",
	treeContainer: "_treeContainer_180yg_30",
	searchContainer: "_searchContainer_180yg_35",
	searchInput: "_searchInput_180yg_39"
}, B = (e) => typeof e == "object" && !!e && e.nodeType === 1, V = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", H = (e, t) => {
	if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
		let n = getComputedStyle(e, null);
		return V(n.overflowY, t) || V(n.overflowX, t) || ((e) => {
			let t = ((e) => {
				if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
				try {
					return e.ownerDocument.defaultView.frameElement;
				} catch {
					return null;
				}
			})(e);
			return !!t && (t.clientHeight < e.scrollHeight || t.clientWidth < e.scrollWidth);
		})(e);
	}
	return !1;
}, U = (e, t, n, r, i, a, o, s) => a < e && o > t || a > e && o < t ? 0 : a <= e && s <= n || o >= t && s >= n ? a - e - r : o > t && s < n || a < e && s > n ? o - t + i : 0, W = (e) => e.parentElement ?? (e.getRootNode().host || null), G = (e, t) => {
	if (typeof document > "u") return [];
	let { scrollMode: n, block: r, inline: i, boundary: a, skipOverflowHiddenElements: o } = t, s = typeof a == "function" ? a : (e) => e !== a;
	if (!B(e)) throw TypeError("Invalid target");
	let c = document.scrollingElement || document.documentElement, l = [], u = e;
	for (; B(u) && s(u);) {
		if (u = W(u), u === c) {
			l.push(u);
			break;
		}
		u != null && u === document.body && H(u) && !H(document.documentElement) || u != null && H(u, o) && l.push(u);
	}
	let d = window.visualViewport?.width ?? innerWidth, f = window.visualViewport?.height ?? innerHeight, { scrollX: p, scrollY: m } = window, { height: h, width: g, top: _, right: v, bottom: y, left: b } = e.getBoundingClientRect(), { top: x, right: S, bottom: C, left: w } = ((e) => {
		let t = window.getComputedStyle(e);
		return {
			top: parseFloat(t.scrollMarginTop) || 0,
			right: parseFloat(t.scrollMarginRight) || 0,
			bottom: parseFloat(t.scrollMarginBottom) || 0,
			left: parseFloat(t.scrollMarginLeft) || 0
		};
	})(e), T = r === "start" || r === "nearest" ? _ - x : r === "end" ? y + C : _ + h / 2 - x + C, E = i === "center" ? b + g / 2 - w + S : i === "end" ? v + S : b - w, D = [];
	for (let e = 0; e < l.length; e++) {
		let t = l[e], { height: a, width: o, top: s, right: u, bottom: x, left: S } = t.getBoundingClientRect();
		if (n === "if-needed" && _ >= 0 && b >= 0 && y <= f && v <= d && (t === c && !H(t) || _ >= s && y <= x && b >= S && v <= u)) return D;
		let C = getComputedStyle(t), w = parseInt(C.borderLeftWidth, 10), O = parseInt(C.borderTopWidth, 10), k = parseInt(C.borderRightWidth, 10), A = parseInt(C.borderBottomWidth, 10), j = 0, M = 0, N = "offsetWidth" in t ? t.offsetWidth - t.clientWidth - w - k : 0, P = "offsetHeight" in t ? t.offsetHeight - t.clientHeight - O - A : 0, F = "offsetWidth" in t ? t.offsetWidth === 0 ? 0 : o / t.offsetWidth : 0, I = "offsetHeight" in t ? t.offsetHeight === 0 ? 0 : a / t.offsetHeight : 0;
		if (c === t) j = r === "start" ? T : r === "end" ? T - f : r === "nearest" ? U(m, m + f, f, O, A, m + T, m + T + h, h) : T - f / 2, M = i === "start" ? E : i === "center" ? E - d / 2 : i === "end" ? E - d : U(p, p + d, d, w, k, p + E, p + E + g, g), j = Math.max(0, j + m), M = Math.max(0, M + p);
		else {
			j = r === "start" ? T - s - O : r === "end" ? T - x + A + P : r === "nearest" ? U(s, x, a, O, A + P, T, T + h, h) : T - (s + a / 2) + P / 2, M = i === "start" ? E - S - w : i === "center" ? E - (S + o / 2) + N / 2 : i === "end" ? E - u + k + N : U(S, u, o, w, k + N, E, E + g, g);
			let { scrollLeft: e, scrollTop: n } = t;
			j = I === 0 ? 0 : Math.max(0, Math.min(n + j / I, t.scrollHeight - a / I + P)), M = F === 0 ? 0 : Math.max(0, Math.min(e + M / F, t.scrollWidth - o / F + N)), T += n - j, E += e - M;
		}
		D.push({
			el: t,
			top: j,
			left: M
		});
	}
	return D;
}, K = (e) => !1 === e ? {
	block: "end",
	inline: "nearest"
} : ((e) => e === Object(e) && Object.keys(e).length !== 0)(e) ? e : {
	block: "start",
	inline: "nearest"
};
function q(e, t) {
	if (!e.isConnected || !((e) => {
		let t = e;
		for (; t && t.parentNode;) {
			if (t.parentNode === document) return !0;
			t = t.parentNode instanceof ShadowRoot ? t.parentNode.host : t.parentNode;
		}
		return !1;
	})(e)) return;
	let n = ((e) => {
		let t = window.getComputedStyle(e);
		return {
			top: parseFloat(t.scrollMarginTop) || 0,
			right: parseFloat(t.scrollMarginRight) || 0,
			bottom: parseFloat(t.scrollMarginBottom) || 0,
			left: parseFloat(t.scrollMarginLeft) || 0
		};
	})(e);
	if (((e) => typeof e == "object" && typeof e.behavior == "function")(t)) return t.behavior(G(e, t));
	let r = typeof t == "boolean" || t == null ? void 0 : t.behavior;
	for (let { el: i, top: a, left: o } of G(e, K(t))) {
		let e = a - n.top + n.bottom, t = o - n.left + n.right;
		i.scroll({
			top: e,
			left: t,
			behavior: r
		});
	}
}
var J = {
	node: "_node_pdhfp_1",
	nestIndentation: "_nestIndentation_pdhfp_6",
	articleNode: "_articleNode_pdhfp_10",
	active: "_active_pdhfp_16",
	searchResultNode: "_searchResultNode_pdhfp_23",
	dropdownButton: "_dropdownButton_pdhfp_28",
	categoryTitle: "_categoryTitle_pdhfp_37",
	articleMeta: "_articleMeta_pdhfp_42",
	searchResultText: "_searchResultText_pdhfp_49",
	articleRecentlyUpdated: "_articleRecentlyUpdated_pdhfp_62"
}, Y = ({ node: e }) => {
	let t = e.publishedAt > Date.now() - 6048e5, n = E({ [J.articleRecentlyUpdated]: t });
	return /* @__PURE__ */ m("span", {
		className: n,
		children: [
			"Updated",
			" ",
			/* @__PURE__ */ p(T, {
				time: e.publishedAt / 1e3,
				refreshRate: 6e4,
				relative: !0
			})
		]
	});
}, X = ({ children: e, article: t, className: n }) => {
	let { collectionId: r } = A();
	function i() {
		r && j.knowledgeInternalKbSearchResultClicked({
			articleId: t.id,
			collectionId: r
		});
	}
	let { articleId: a } = A(), o = d(null);
	return u(() => {
		t.id === a && o.current && q(o.current, {
			block: "nearest",
			scrollMode: "if-needed"
		});
	}, [a, t]), /* @__PURE__ */ p(O, {
		ref: o,
		to: {
			pathname: `article/${t.id}`,
			search: window.location.search
		},
		className: ({ isActive: e }) => E(J.node, J.articleNode, e && J.active, n),
		onClick: i,
		"data-testid": "article-node",
		children: e
	});
}, Z = ({ result: e }) => /* @__PURE__ */ m(X, {
	article: e,
	className: J.searchResultNode,
	children: [
		/* @__PURE__ */ p(w.Heading, {
			variant: "heading-3",
			children: e.title
		}),
		/* @__PURE__ */ m(w.Paragraph, {
			variant: "5",
			className: J.articleMeta,
			children: [/* @__PURE__ */ p(Y, { node: e }), e.parentCategory?.title ? ` • ${e.parentCategory.title}` : ""]
		}),
		e.searchMatchedOn?.body && /* @__PURE__ */ p("p", {
			className: E(J.articleMeta, J.searchResultText),
			dangerouslySetInnerHTML: { __html: e.searchMatchedOn?.body }
		})
	]
}), Q = 30, $ = ({ treeData: t, languageData: n, collectionId: r }) => {
	let { collection: i, categories: a } = t, { searchValue: o, setSearchValue: c, clearSearch: l, urlSearch: u } = s(), d = P(), f = n.selectedLanguage.languageId, g = e({
		variables: {
			collectionId: r,
			languageId: f,
			searchTerms: u,
			limit: Q
		},
		skip: !u,
		onCompleted: (e) => d({
			languageId: f,
			searchTerms: o,
			searchResults: e.knowledgeBase?.articleSearch?.results.map((e) => e.id) || [],
			origin: { internalKb: { id: t.collection.id } }
		})
	}), _ = g.loading || g.data || g.error;
	return /* @__PURE__ */ m(b, {
		className: z.categoryTreeSidebar,
		children: [/* @__PURE__ */ p(ne, {
			collection: i,
			treeData: t,
			languageData: n,
			children: /* @__PURE__ */ p(te, {
				searchValue: o,
				setSearchValue: c,
				clearSearch: l
			})
		}), /* @__PURE__ */ m(h, {
			height: "100%",
			className: z.treeContainer,
			children: [!_ && /* @__PURE__ */ p(R, { categories: a }), _ && /* @__PURE__ */ p(ee, { ...g })]
		})]
	});
}, ee = ({ loading: e, data: t, error: n }) => {
	if (e || !t) return /* @__PURE__ */ p(c, {});
	let r = t.knowledgeBase?.articleSearch.results;
	return !r || r.length === 0 || n ? /* @__PURE__ */ p(b, {
		height: "100%",
		justifyContent: "center",
		alignItems: "center",
		flexDirection: "column",
		children: /* @__PURE__ */ p(y, {
			title: n ? "There has been an issue" : "No results found for this search",
			description: n ? "Please try again" : "Please try another search term"
		})
	}) : /* @__PURE__ */ p(f, { children: r.map((e) => /* @__PURE__ */ p(Z, { result: e }, e.id)) });
}, te = ({ searchValue: e, setSearchValue: t, clearSearch: n }) => /* @__PURE__ */ p(b, {
	className: z.searchContainer,
	children: /* @__PURE__ */ p(C, {
		className: z.searchInput,
		value: e,
		onChange: (e) => t(e.target.value),
		placeholder: "Search...",
		suffix: {
			type: "custom",
			value: /* @__PURE__ */ p(b, {
				alignItems: "center",
				padding: "0 100",
				children: /* @__PURE__ */ p(S, {
					variant: "tertiary",
					disabled: !e,
					icon: e ? "close" : "search",
					onClick: e ? n : void 0
				})
			}),
			noWrap: !0
		}
	})
}), ne = ({ children: e, collection: t, languageData: r, treeData: i }) => {
	let a = n.internalKBDashboard();
	return /* @__PURE__ */ m("div", { children: [/* @__PURE__ */ m(b, {
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		className: z.headingContainer,
		children: [/* @__PURE__ */ m(b, {
			flexDirection: "row",
			alignItems: "center",
			gap: "200",
			children: [
				/* @__PURE__ */ p(D, {
					to: a,
					className: z.backButton,
					children: /* @__PURE__ */ p(x, { name: "angle-left" })
				}),
				/* @__PURE__ */ p(l, { color: i.theme.colors.icon }),
				/* @__PURE__ */ p(w.Heading, {
					variant: "heading-2",
					as: "div",
					children: t.title
				})
			]
		}), /* @__PURE__ */ p(re, { languageData: r })]
	}), e] });
}, re = ({ languageData: e }) => {
	let t = e.selectedLanguage.description, { setSelectedLanguageId: n } = i();
	return /* @__PURE__ */ p(_, {
		fixed: !0,
		dropdown: /* @__PURE__ */ p(N, {
			languageData: e,
			selectedLanguageId: e.selectedLanguage.languageId,
			setSelectedLanguageId: n
		}),
		children: t
	});
};
// src/pages/collection/collectionPage.tsx
function ie() {
	let { collectionId: e } = A();
	if (!e) throw Error("Collection ID not defined in Internal Knowledge Base collection page.");
	let { selectedLanguageId: t } = i();
	u(() => {
		j.knowledgeCollectionViewed({
			collectionId: e,
			source: "internal-kb"
		});
	}, [e]);
	let { data: n, loading: r, error: a } = o({ selectedLanguageId: t });
	if (a) throw a;
	return r || !n ? /* @__PURE__ */ p(c, {}) : /* @__PURE__ */ p(ae, {
		languageData: n,
		collectionId: e
	});
}
var ae = ({ collectionId: e, languageData: t }) => {
	let { loading: n, data: i, error: a } = r({
		variables: {
			collectionId: e,
			languageId: t.selectedLanguage.languageId
		},
		fetchPolicy: "cache-and-network"
	});
	if (a) throw a;
	if (n || !i) return /* @__PURE__ */ p(c, {});
	if (!i?.knowledgeBase) throw Error("Unable to find data for Kb");
	return /* @__PURE__ */ p(oe, {
		collectionId: e,
		languageData: t,
		treeData: i.knowledgeBase,
		children: /* @__PURE__ */ p(k, {})
	});
}, oe = ({ collectionId: e, languageData: t, treeData: n, children: r }) => /* @__PURE__ */ m(b, {
	height: "100%",
	children: [/* @__PURE__ */ p($, {
		collectionId: e,
		languageData: t,
		treeData: n
	}), /* @__PURE__ */ p(b, {
		className: M.articlePageContainer,
		children: r
	})]
}), se = ie;
export { se as default };

//# sourceMappingURL=collection-OxEiFkiE.js.map